import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import { IPost, IPostListRequest, PostState } from "@/types/post";
import CustomRequest from "../customRequest";
import { IPostCreateRequest } from "@/types/post";

const actions: ActionTree<PostState, RootState> = {
  // async salesUpdate(
  //   { commit },
  //   datas: {
  //     proposal_id: number;
  //     params: IPostUpdateRequest & { status_id: number };
  //   }
  // ) {
  //   const { error } = await CustomRequest.patch<IPagination<IProposal>>({
  //     uri: `/sales/proposal/${datas.proposal_id}`,
  //     params: datas.params,
  //     commit,
  //     target: "single",
  //     flash: true,
  //   });

  //   return !error;
  // },

  async salesProposalPostCreate(
    { commit },
    datas: {
      postable_id: number;
      params: IPostCreateRequest;
    }
  ) {
    const { error } = await CustomRequest.post<IPagination<IPost>>({
      uri: `/sales/proposal/${datas.postable_id}/post`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesOfferPostCreate(
    { commit },
    datas: {
      postable_id: number;
      params: IPostCreateRequest;
    }
  ) {
    const { error } = await CustomRequest.post<IPagination<IPost>>({
      uri: `/sales/offer/${datas.postable_id}/post`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesGetList({ commit }, params: IPostListRequest) {
    await CustomRequest.get<IPagination<IPost>>({
      uri: "/sales/post",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
